import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { WebPanelLocationQuery } from './WebPanelLocationQuery.graphql.ts';
import type {
	WebPanelLocationQuery as WebPanelLocationQueryType,
	WebPanelLocationQueryVariables,
} from './__types__/WebPanelLocationQuery.ts';

export function preloadWebPanelLocation(variables: WebPanelLocationQueryVariables) {
	return query<WebPanelLocationQueryType, WebPanelLocationQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: WebPanelLocationQuery,
		variables,
	});
}
